export const ShiftsDropDown = [
    {name:'Shift A',value:'ShiftA'},{name : 'Shift B',value:'ShiftB'},{name : 'Shift C',value:'ShiftC'},{name : 'General',value:'General'}
]